import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import useTypedSelector from './useTypedSelector';
import {actions} from '../state/action';
import {getUserAgent} from '../util/userAgent';

export default function useUserAgent() {
  const [userAgent] = useTypedSelector(state => [state.common.userAgent]);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!userAgent) {
      const newUserAgent = getUserAgent(window.navigator.userAgent);
      dispatch(actions.setUserAgent(newUserAgent));
    }
  }, [userAgent, dispatch]);
  return userAgent;
}
